import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule
} from '@angular/material';
import { AppSettings } from './app.settings';
import { ScrollableFixedDirective } from './core/menu/scrollable-fixed-directive';
import { TeslaCommonModule } from '@tesla/angular2-tesla-common/tesla-common';
import { HomeComponent } from './commonUI/home/home.component';
import { ProposalGapConfirmComponent } from './proposal/crud/proposal-gap-confirm/proposal-gap-confirm.component';
import { ProposalbasicinfoComponent } from './proposal/crud/proposalbasicinfo/proposalbasicinfo.component';
import { ProposalLogisticsComponent } from './proposal/crud/proposallogistics/proposallogistics.component';
import { PackagelevelComponent } from './proposal/crud/packagelevel/packagelevel.component';
import { ProposalComponent } from './proposal/crud/proposal.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProposalsummaryComponent } from './proposal/crud/proposalsummary/proposalsummary.component';
import { ProposaloverrideComponent } from './proposal/crud/proposaloverride/proposaloverride.component';
import { ProposalService } from './services/proposal.service';
import { LocalstorageService } from './services/localstorage.service';
import { AppGlobalDataService } from './services/appglobaldata.service';
import { BreadcrumbsComponent } from './commonUI/breadcrumbs/breadcrumbs.component';
import { ProposallistComponent } from './proposallist/proposallist.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormService } from './services/form';
import { FieldValidationErrorComponent } from './commonUI/fieldvalidationerror/fieldvalidationerror.component';
import { TabNavigationComponent } from './commonUI/tab-navigation/tab-navigation.component';
import { ToastComponent } from './commonUI/toaster-notification/toaster-notification.component';
import { ToastService } from './services/toaster/toaster.service';
import { ReversePipe } from './core/pipes/reverse.pipe';
import { HintComponent } from './commonUI/hint/hint.component';
import { PendingproposallistComponent } from './proposal/lists/pendingproposallist/pendingproposallist.component';
import { HttpInterceptorService } from './services/httpinterceptor.service';
import { PackageLevelTemplateComponent } from './packagelevel-template/packagelevel-template.component';
import { PackageLevelTemplateListComponent } from './packagelevel-template/lists/packagelevel-template-list.component';
import { ReviewproposallistComponent } from './proposal/lists/reivewproposallist/reivewproposallist.component';
import { UnreadcommentslistComponent } from './proposal/lists/unreadcommentslist/unreadcommentslist.component';
import { ProposalimagesComponent } from './proposal/crud/proposalimages/proposalimages.component';
import { ImageuploadComponent } from './commonUI/imageupload/imageupload.component';
import { ImageuploaderComponent } from './commonUI/image-uploader/image-uploader.component';
import { PartlisthotrequestComponent } from './parts/partlisthotrequest/partlisthotrequest.component';
import { SuppliercontextComponent } from './commonUI/suppliercontext/suppliercontext.component';
import { PeCreateproposalComponent } from './proposal/pe/pe-createproposal/pe-createproposal.component';
import { ProposalSnapshotComponent } from './proposal/pe/proposal-snapshot/proposal-snapshot.component';
import { ImagecontainerComponent } from './commonUI/imagecontainer/imagecontainer.component';
import { SpinnerComponent } from './commonUI/spinner/spinner.component';
import { SpinnerOverlayWrapperModule } from './commonUI/spinner-overlay-wrapper/spinner-overlay-wrapper.module';
import { SpinnerService } from './services/spinner.service';
import { RejectedProposalListComponent } from './proposal/lists/rejected-proposal-list/rejected-proposal-list.component';
import { PeAssignmentComponent } from './pe/pe-assignment/pe-assignment.component';
import { ViewProposalComponent } from './proposal/view-proposal/view-proposal.component';
import { ProposalDetailsComponent } from './proposal/proposal-details/proposal-details.component';
import { CopyfromProposalListComponent } from './proposal/lists/copyfrom-proposal-list/copyfrom-proposal-list.component';
import { DocumentuploadComponent } from './commonUI/documentupload/documentupload.component';
import { DocumentcontainerComponent } from './commonUI/documentcontainer/documentcontainer.component';
import { SavedProposalsComponent } from './proposal/lists/saved-proposals/saved-proposals.component';
import { ProposalInternalCommentComponent } from './proposal/proposal-internal-comment/proposal-internal-comment.component';
import { ProposalExternalCommentComponent } from './proposal/proposal-external-comment/proposal-external-comment.component';
import { ProposalCommunicationComponent } from './proposal/crud/proposal-communication/proposal-communication.component';
import { SearchPartComponent } from './parts/search-part/search-part.component';
import { SessionstorageService } from './services/sessionstorage.service';
import { NoRecordsMessageComponent } from './commonUI/no-records-message/no-records-message.component';
import { SearchPartPeComponent } from './proposal/pe/search-part-pe/search-part-pe.component';
import { BackbuttonComponent } from './commonUI/backbutton/backbutton.component';
import { NotificationComponent } from './commonUI/notification/notification.component';
import { PackagelevelTemplateViewComponent } from './packagelevel-template/packagelevel-template-view/packagelevel-template-view.component';
import {
    NGTdsModule,
    TslBadgeModule,
    TslBarChart,
    TslChartsModule,
    TslSpinnerModule,
    TslProgressBarModule,
    TslFileDropModule,
} from '@tesla/ng-tds';
import { HeaderComponent } from './core/header/header.component';
import { MenuComponent } from './core/menu/menu.component';
import { CriticalPartIconComponent } from './commonUI/critical-part-icon/critical-part-icon';
import {
    AuthModule,
    AuthService,
    PREDEFINED_CONFIGS,
    AuthConfigProvider,
} from '@tesla/ng-auth';
import { ExternalAuthService } from './ExternalAuthService';
import { landingpageComponent } from './commonUI/landingpage/landingpage.component';
import { loginassuppliercontextComponent } from './commonUI/loginassuppliercontext/loginassuppliercontext.component';
import { UserUOMPrefComponent } from './commonUI/useruompref/useruompref.component';
import { PhysicalinspectionComponent } from './proposal/crud/physicalinspection/physicalinspection.component';
import { PendinginspectionproposallistComponent } from './proposal/lists/pendinginspectionproposallist/pendinginspectionproposallist.component';
import { InfotooltipComponent } from './commonUI/infotooltip/infotooltip.component';
import { AdhocrequestComponent } from './proposal/pe/adhocrequest/adhocrequest.component';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { ProposalHistoryComponent } from './proposal/crud/proposal-history/proposal-history.component';
import { ExemptedPartsListComponent } from './proposal/pe/exemptedpartslist/exemptedparts-list.component';
import { PeAddsourcetypeComponent } from './proposal/pe/pe-addsourcetype/pe-addsourcetype.component';
import { WarningComponent } from './commonUI/warning/warning.component';
import { DuedateextensionHistoryComponent } from './commonUI/duedateextension-history/duedateextension-history.component';
import { PeBulkuploadComponent } from './proposal/pe/pe-bulkupload/pe-bulkupload.component';
import { ProposalRejectionReasonComponent } from './commonUI/proposal-rejection-reason/proposal-rejection-reason.component';
import { ApprovedProposalListComponent } from './proposal/lists/approved-proposal-list/approved-proposal-list.component';
import { IncompleteProposalListComponent } from './proposal/lists/incomplete-proposal-list/incomplete-proposal-list.component';
import { SubmittedProposalListComponent } from './proposal/lists/submitted-proposal-list/submitted-proposal-list.component';
import { ClipboardModule } from 'ngx-clipboard';
import { AddNewAssignmentComponent } from './pe/pe-assignment/add-new-assignment/add-new-assignment.component';
import { PeBulkcopyComponent } from './proposal/pe/pe-bulkcopy/pe-bulkcopy.component';
import { PeAdhocduedateExtensionRequestDashboardComponent } from './proposal/pe/pe-adhocduedate-extension-request-dashboard/pe-adhocduedate-extension-request-dashboard.component';
import { PeSyncproposalComponent } from './proposal/pe/pe-syncproposal/pe-syncproposal.component';
import { PackageEngineerAssignmentComponent } from './pe/package-engineer-assignment/package-engineer-assignment.component';
import { AssignedPeComponent } from './pe/package-engineer-assignment/assigned-pe/assigned-pe.component';
import { UnassignedPeComponent } from './pe/package-engineer-assignment/unassigned-pe/unassigned-pe.component';
import { ReassignPeComponent } from './pe/package-engineer-assignment/reassign-pe/reassign-pe.component';
import { AssignNewPeComponent } from './pe/package-engineer-assignment/assign-new-pe/assign-new-pe.component';
import { PeBulkpackagetemplateComponent } from './proposal/pe/pe-bulkpackagetemplate/pe-bulkpackagetemplate.component';
import { PeAddpackageengineerComponent } from './proposal/pe/pe-addpackageengineer/pe-addpackageengineer.component';
import { PeExemptpartReasonComponent } from './commonUI/pe-exemptpart-reason/pe-exemptpart-reason.component';
import { OpenactionsComponent } from './proposal/lists/openactions/openactions.component';
import { AdminInfoButtonsComponent } from './admin/admin-info-buttons/admin-info-buttons.component';
import { InfoButtonEditComponent } from './admin/info-button-edit/info-button-edit.component';
import { InfotooltipDynamicComponent } from './commonUI/infotooltip-dynamic/infotooltip-dynamic.component';
import { InfobuttonImageuploadComponent } from './commonUI/infobutton-imageupload/infobutton-imageupload.component';
import { InfobuttonDocumentuploadComponent } from './commonUI//infobutton-documentupload/infobutton-documentupload.component';
import { TPMEstimateRequestComponent } from './estimates/tpm/tpm-bulk-estimate-request/tpm-bulk-estimate-request.component';
import { EstimateRequestsComponent } from './estimates/tpm/estimate-request-container-tpm/estimate-request-container-tpm.component';
import { EstimaterequestlistPEComponent } from './estimates/pe/estimate-request-list-pe/estimate-request-list-pe.component';
import { BulkuploadestimatesComponent } from './estimates/pe/pe-bulk-upload-estimates/pe-bulk-upload-estimates.component';
import { EstimatesComponent } from './estimates/pe/estimates-container-pe/estimates-container-pe.component';
import { EstimateRequestListTpmComponent } from './estimates/tpm/estimate-request-list-tpm/estimate-request-list-tpm.component';
import { PeViewEstimteComponent } from './estimates/pe/pe-view-estimate/pe-view-estimate.component';
import { EstimateDetailsComponent } from './estimates/common/estimate-details/estimate-details.component';
import { TpmReviewEstimateComponent } from './estimates/tpm/tpm-review-estimate/tpm-review-estimate.component';
import { EstimateCommentComponent } from './estimates/common/estimate-comment/estimate-comment.component';
import { CriticalPartsComponent } from './parts/critical-part/critical-part.component';
import { OverlayModule } from '@angular/cdk/overlay';

export function appConstantFactory(): AppSettings {
    return <AppSettings>window['APP_CONSTANTS'];
}
@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        CriticalPartIconComponent,
        ProposalGapConfirmComponent,
        ProposalbasicinfoComponent,
        ProposalLogisticsComponent,
        PackagelevelComponent,
        ProposalComponent,
        ProposalsummaryComponent,
        ProposaloverrideComponent,
        BreadcrumbsComponent,
        ProposallistComponent,
        FieldValidationErrorComponent,
        TabNavigationComponent,
        ToastComponent,
        ReversePipe,
        HintComponent,
        PendingproposallistComponent,
        PackageLevelTemplateComponent,
        PackageLevelTemplateListComponent,
        ReviewproposallistComponent,
        ProposalimagesComponent,
        ImageuploadComponent,
        ImageuploaderComponent,
        PartlisthotrequestComponent,
        SuppliercontextComponent,
        PeCreateproposalComponent,
        ProposalSnapshotComponent,
        ImagecontainerComponent,
        RejectedProposalListComponent,
        PeAssignmentComponent,
        ViewProposalComponent,
        ProposalDetailsComponent,
        CopyfromProposalListComponent,
        DocumentuploadComponent,
        DocumentcontainerComponent,
        SavedProposalsComponent,
        ProposalInternalCommentComponent,
        ProposalExternalCommentComponent,
        ProposalCommunicationComponent,
        SearchPartComponent,
        CriticalPartsComponent,
        NoRecordsMessageComponent,
        SearchPartPeComponent,
        BackbuttonComponent,
        NotificationComponent,
        WarningComponent,
        PackagelevelTemplateViewComponent,
        HeaderComponent,
        ScrollableFixedDirective,
        MenuComponent,
        landingpageComponent,
        loginassuppliercontextComponent,
        UserUOMPrefComponent,
        UnreadcommentslistComponent,
        PhysicalinspectionComponent,
        PendinginspectionproposallistComponent,
        InfotooltipComponent,
        AdhocrequestComponent,
        ProposalHistoryComponent,
        ExemptedPartsListComponent,
        PeAddsourcetypeComponent,
        DuedateextensionHistoryComponent,
        PeBulkuploadComponent,
        ProposalRejectionReasonComponent,
        ApprovedProposalListComponent,
        IncompleteProposalListComponent,
        SubmittedProposalListComponent,
        AddNewAssignmentComponent,
        PeBulkcopyComponent,
        PeAdhocduedateExtensionRequestDashboardComponent,
        PeSyncproposalComponent,
        PackageEngineerAssignmentComponent,
        AssignedPeComponent,
        UnassignedPeComponent,
        ReassignPeComponent,
        AssignNewPeComponent,
        PeAddpackageengineerComponent,
        PeBulkpackagetemplateComponent,
        PeExemptpartReasonComponent,
        OpenactionsComponent,
        AdminInfoButtonsComponent,
        InfoButtonEditComponent,
        InfotooltipDynamicComponent,
        InfobuttonImageuploadComponent,
        InfobuttonDocumentuploadComponent,
        TPMEstimateRequestComponent,
        EstimateRequestsComponent,
        EstimaterequestlistPEComponent,
        BulkuploadestimatesComponent,
        EstimatesComponent,
        EstimateRequestListTpmComponent,
        PeViewEstimteComponent,
        EstimateDetailsComponent,
        TpmReviewEstimateComponent,
        EstimateCommentComponent,
    ],
    imports: [
        OverlayModule,
        BrowserModule,
        AuthModule.forRoot(null),
        AppRoutingModule,
        TeslaCommonModule,
        FormsModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatMenuModule,
        MatSnackBarModule,
        MatDialogModule,
        HttpClientModule,
        CoreModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        SpinnerOverlayWrapperModule,
        NGTdsModule,
        TslBadgeModule,
        TslChartsModule,
        TslSpinnerModule,
        TslProgressBarModule,
        TslFileDropModule,
        LoggerModule.forRoot({
            level: NgxLoggerLevel.OFF,
            serverLogLevel: NgxLoggerLevel.OFF,
        }),
        ClipboardModule,
    ],
    providers: [
        { provide: AuthService, useClass: ExternalAuthService },
        AppSettings,
        AppGlobalDataService,
        ProposalService,
        LocalstorageService,
        SessionstorageService,
        FormService,
        ToastService,
        { provide: AppSettings, useFactory: appConstantFactory },
        ExternalAuthService,
        SpinnerService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
    entryComponents: [
        DuedateextensionHistoryComponent,
        ProposalRejectionReasonComponent,
        ReassignPeComponent,
        AssignNewPeComponent,
        PeExemptpartReasonComponent,
        InfoButtonEditComponent,
        ProposalGapConfirmComponent
    ],
})
export class AppModule {}
